<template>
  <dl class="grid grid-cols-1 gap-y-8">
    <div>
      <dt class="text-sm font-medium text-gray-500">Audience name</dt>
      <dd class="mt-1 text-sm text-gray-900">
        {{ audience.model.name }}
      </dd>
    </div>
    <div>
      <dt class="text-sm font-medium text-gray-500">Estimated audience size</dt>
      <dd class="mt-1 text-sm text-gray-900">
        <span v-if="audience.model.approximate_count_lower_bound">
          {{ estimatedSize.lower }}
          -
          {{ estimatedSize.upper }}
        </span>
        <span v-else>-</span>
      </dd>
    </div>
    <div>
      <dt class="text-sm font-medium text-gray-500">Audience source</dt>
      <dd class="mt-1 text-sm text-gray-900">Facebook</dd>
    </div>
    <div>
      <dt class="text-sm font-medium text-gray-500">Audience type</dt>
      <dd class="mt-1 text-sm text-gray-900">
        <span v-if="audience.model_type === 'facebook_saved_audiences'">Saved audience</span>
        <template v-else>
          <span>Custom audience</span>
          <br />
          <span class="text-xs text-gray-500">{{ audience.model.subtype }}</span>
        </template>
      </dd>
    </div>
  </dl>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    audience: {
      type: Object,
      required: true,
    },
  },
  computed: {
    estimatedSize() {
      const lower = Numbro(
        Number.parseInt(this.audience.model.approximate_count_lower_bound || 0, 10)
      ).format({
        thousandSeparated: true,
      });
      const upper = Numbro(
        Number.parseInt(this.audience.model.approximate_count_upper_bound || 0, 10)
      ).format({
        thousandSeparated: true,
      });

      return {
        lower,
        upper,
      };
    },
  },
};
</script>
